"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as c } from "react/jsx-runtime";
import { useTheme as a } from "../../hooks.js";
import { useIsInverseVariant as v } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: s, size: e = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = v(), r = s !== null && s !== void 0 ? s : n ? l.colors.inverse : l.colors.neutralHigh, { skinName: o } = a();
    return o.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ c("path", {
                fill: r,
                d: "M16.454 11.798a4.472 4.472 0 1 1-8.944 0 4.472 4.472 0 0 1 8.944 0"
            }),
            /* @__PURE__ */ c("path", {
                fill: r,
                d: "M22 11.583v.358c-.036 0-.036.036-.036.036-.02.02-.03.03-.033.04q-.004.01-.003.031v.036c-1.824 4.079-5.545 6.512-9.946 6.512s-8.122-2.433-9.946-6.44v-.036C2 12.084 2 12.084 2 12.048v-.429c.02-.02.03-.03.033-.04q.004-.01.003-.032v-.035C3.86 7.432 7.58 5 11.982 5s8.122 2.433 9.982 6.476v.036c.02.02.03.029.033.04q.004.01.003.031m-18.533.215c1.646 3.363 4.794 5.367 8.515 5.367s6.87-2.004 8.515-5.367c-1.645-3.363-4.794-5.367-8.515-5.367-3.72 0-6.87 2.004-8.515 5.367"
            })
        ]
    })) : o.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ c("path", {
                fill: r,
                d: "M11.982 7.208c-2.577 0-4.653 2.137-4.653 4.79s2.076 4.79 4.653 4.79 4.653-2.138 4.653-4.79-2.077-4.79-4.653-4.79m0 8.106c-1.788 0-3.22-1.475-3.22-3.316s1.432-3.316 3.22-3.316 3.22 1.475 3.22 3.316-1.432 3.316-3.22 3.316"
            }),
            /* @__PURE__ */ c("path", {
                fill: r,
                d: "M22 12.146v-.37q0-.022-.003-.034c-.004-.01-.012-.02-.033-.04v-.038C20.104 7.504 16.383 5 11.982 5S3.86 7.504 2.036 11.701v.037q0 .022-.003.034c-.004.01-.012.02-.033.04v.445q0 .022.003.034c.004.01.012.02.033.04v.038C3.86 16.496 7.581 19 11.982 19s8.122-2.504 9.946-6.706v-.037q0-.021.003-.033c.004-.01.012-.02.033-.04 0 0 0-.038.036-.038m-10.018 5.375c-3.72 0-6.87-2.063-8.514-5.523 1.645-3.464 4.793-5.523 8.514-5.523s6.87 2.059 8.514 5.523c-1.645 3.464-4.793 5.523-8.514 5.523"
            })
        ]
    })) : /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ c("path", {
            fill: r,
            d: "M21.705 12.374c-.194.239-4.83 5.774-9.678 5.774s-9.535-5.535-9.731-5.77a.59.59 0 0 1-.003-.76l.003-.003c.235-.279 4.874-5.77 9.706-5.77 4.851 0 9.507 5.538 9.703 5.773a.59.59 0 0 1 0 .756m-9.678 4.58c3.602 0 7.3-3.736 8.409-4.955-1.115-1.218-4.835-4.96-8.434-4.96-3.603 0-7.32 3.736-8.435 4.957 1.124 1.219 4.86 4.958 8.46 4.958m2.456-4.874c0-2.252-1.893-2.442-2.38-2.453-.07-.003-.157-.003-.233-.003-.501.003-2.353.17-2.353 2.442 0 2.275 1.871 2.451 2.37 2.46q.113 0 .227-.003c.473-.008 2.37-.185 2.37-2.443"
        })
    }));
}, u = h;
export { u as default };
